var map = {
	"./AccountPicker": [
		"0414",
		9,
		"chunk-2d0be333",
		"chunk-02e05c92"
	],
	"./AccountPicker.vue": [
		"0414",
		9,
		"chunk-2d0be333",
		"chunk-02e05c92"
	],
	"./AccountRegister": [
		"80bd",
		9,
		"chunk-7779ba00"
	],
	"./AccountRegister.vue": [
		"80bd",
		9,
		"chunk-7779ba00"
	],
	"./Auth/Dashboard": [
		"0f52",
		9,
		"chunk-13828b66",
		"chunk-e5b0a5f6"
	],
	"./Auth/Dashboard.m": [
		"1ea5",
		9,
		"chunk-13828b66",
		"chunk-1915ef8c"
	],
	"./Auth/Dashboard.m.vue": [
		"1ea5",
		9,
		"chunk-13828b66",
		"chunk-1915ef8c"
	],
	"./Auth/Dashboard.vue": [
		"0f52",
		9,
		"chunk-13828b66",
		"chunk-e5b0a5f6"
	],
	"./Auth/FindAccount": [
		"956b",
		9,
		"chunk-06b4c4fd"
	],
	"./Auth/FindAccount.vue": [
		"956b",
		9,
		"chunk-06b4c4fd"
	],
	"./Auth/Login": [
		"7f71",
		9,
		"chunk-22568233"
	],
	"./Auth/Login.m.backup": [
		"08a4",
		9,
		"chunk-70a227b4"
	],
	"./Auth/Login.m.backup.vue": [
		"08a4",
		9,
		"chunk-70a227b4"
	],
	"./Auth/Login.vue": [
		"7f71",
		9,
		"chunk-22568233"
	],
	"./Auth/Logout": [
		"3bf4",
		9,
		"chunk-2d0c4c53"
	],
	"./Auth/Logout.vue": [
		"3bf4",
		9,
		"chunk-2d0c4c53"
	],
	"./Auth/Register": [
		"5a00",
		9,
		"chunk-50d76663"
	],
	"./Auth/Register.m.backup": [
		"adb6",
		9,
		"chunk-5ceb6bce"
	],
	"./Auth/Register.m.backup.vue": [
		"adb6",
		9,
		"chunk-5ceb6bce"
	],
	"./Auth/Register.vue": [
		"5a00",
		9,
		"chunk-50d76663"
	],
	"./Auth/TermsContent": [
		"db99",
		9,
		"chunk-586d15b2"
	],
	"./Auth/TermsContent.vue": [
		"db99",
		9,
		"chunk-586d15b2"
	],
	"./Cookies": [
		"8a36",
		9,
		"chunk-028bcb52"
	],
	"./Cookies.vue": [
		"8a36",
		9,
		"chunk-028bcb52"
	],
	"./CustomSelectBox": [
		"9fa7",
		9,
		"chunk-2d0be333",
		"chunk-3b441cf2"
	],
	"./CustomSelectBox.vue": [
		"9fa7",
		9,
		"chunk-2d0be333",
		"chunk-3b441cf2"
	],
	"./Development/DevelopMain": [
		"26c8",
		9,
		"chunk-56e2e7b4"
	],
	"./Development/DevelopMain.vue": [
		"26c8",
		9,
		"chunk-56e2e7b4"
	],
	"./Development/Development": [
		"7dbf",
		9,
		"chunk-f6640758"
	],
	"./Development/Development.vue": [
		"7dbf",
		9,
		"chunk-f6640758"
	],
	"./Extform/Extform": [
		"a7ec",
		9,
		"chunk-ff2cad96"
	],
	"./Extform/Extform.vue": [
		"a7ec",
		9,
		"chunk-ff2cad96"
	],
	"./Home": [
		"57da",
		9,
		"chunk-732b24c1"
	],
	"./Home.m": [
		"db49",
		9,
		"chunk-1cf6e4b6"
	],
	"./Home.m.vue": [
		"db49",
		9,
		"chunk-1cf6e4b6"
	],
	"./Home.vue": [
		"57da",
		9,
		"chunk-732b24c1"
	],
	"./Layout/Accordion": [
		"ac53",
		9,
		"chunk-2d213336"
	],
	"./Layout/Accordion.vue": [
		"ac53",
		9,
		"chunk-2d213336"
	],
	"./Layout/AccordionItem": [
		"de79",
		9,
		"chunk-2d229819"
	],
	"./Layout/AccordionItem.vue": [
		"de79",
		9,
		"chunk-2d229819"
	],
	"./Layout/AccordionItem2": [
		"8442",
		9,
		"chunk-2d0ddf70"
	],
	"./Layout/AccordionItem2.vue": [
		"8442",
		9,
		"chunk-2d0ddf70"
	],
	"./Layout/DevelopLayout": [
		"2c69",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-79862ab2"
	],
	"./Layout/DevelopLayout.vue": [
		"2c69",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-79862ab2"
	],
	"./Layout/Footer": [
		"3364",
		9,
		"chunk-65f7d8cc"
	],
	"./Layout/Footer.m": [
		"b9d2",
		9,
		"chunk-2d210f9b"
	],
	"./Layout/Footer.m.vue": [
		"b9d2",
		9,
		"chunk-2d210f9b"
	],
	"./Layout/Footer.vue": [
		"3364",
		9,
		"chunk-65f7d8cc"
	],
	"./Layout/Header": [
		"d118",
		9,
		"chunk-13828b66",
		"chunk-769427c1"
	],
	"./Layout/Header.m": [
		"6228",
		9,
		"chunk-13828b66",
		"chunk-29ad5e3c",
		"chunk-6254a71a"
	],
	"./Layout/Header.m.vue": [
		"6228",
		9,
		"chunk-13828b66",
		"chunk-29ad5e3c",
		"chunk-6254a71a"
	],
	"./Layout/Header.vue": [
		"d118",
		9,
		"chunk-13828b66",
		"chunk-769427c1"
	],
	"./Layout/Layout": [
		"7ad1",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-33b7e422"
	],
	"./Layout/Layout.m.backup": [
		"dc17",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-44b7d9e2"
	],
	"./Layout/Layout.m.backup.vue": [
		"dc17",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-44b7d9e2"
	],
	"./Layout/Layout.vue": [
		"7ad1",
		9,
		"chunk-13828b66",
		"chunk-ffeccb0e",
		"chunk-29ad5e3c",
		"chunk-33b7e422"
	],
	"./Layout/ManagementLayout": [
		"c6e2",
		9,
		"chunk-66521e8c"
	],
	"./Layout/ManagementLayout.vue": [
		"c6e2",
		9,
		"chunk-66521e8c"
	],
	"./Layout/MerchantLayout": [
		"8e89",
		9,
		"chunk-13828b66",
		"chunk-29ad5e3c",
		"chunk-6ca4f084"
	],
	"./Layout/MerchantLayout.vue": [
		"8e89",
		9,
		"chunk-13828b66",
		"chunk-29ad5e3c",
		"chunk-6ca4f084"
	],
	"./Layout/ModalHelp": [
		"7596",
		9,
		"chunk-2d0d6f71"
	],
	"./Layout/ModalHelp.vue": [
		"7596",
		9,
		"chunk-2d0d6f71"
	],
	"./Layout/ModalMessage": [
		"cae8",
		9,
		"chunk-2d221a47"
	],
	"./Layout/ModalMessage.m": [
		"30c4",
		9,
		"chunk-2c99829f"
	],
	"./Layout/ModalMessage.m.vue": [
		"30c4",
		9,
		"chunk-2c99829f"
	],
	"./Layout/ModalMessage.vue": [
		"cae8",
		9,
		"chunk-2d221a47"
	],
	"./Layout/ModalView": [
		"8b14",
		9,
		"chunk-2d0e8bc3"
	],
	"./Layout/ModalView.m": [
		"d6e6",
		9,
		"chunk-bc5cd858"
	],
	"./Layout/ModalView.m.vue": [
		"d6e6",
		9,
		"chunk-bc5cd858"
	],
	"./Layout/ModalView.vue": [
		"8b14",
		9,
		"chunk-2d0e8bc3"
	],
	"./Layout/Spinner": [
		"b701",
		9,
		"chunk-14726fb6"
	],
	"./Layout/Spinner.vue": [
		"b701",
		9,
		"chunk-14726fb6"
	],
	"./Management/DetailSearchComponent": [
		"c7b6",
		9,
		"chunk-2d217c3e"
	],
	"./Management/DetailSearchComponent.vue": [
		"c7b6",
		9,
		"chunk-2d217c3e"
	],
	"./Management/Login": [
		"f3ba",
		9,
		"chunk-188e16a8"
	],
	"./Management/Login.vue": [
		"f3ba",
		9,
		"chunk-188e16a8"
	],
	"./Management/MerchantManagement": [
		"51d5",
		9,
		"chunk-2d0be333",
		"chunk-77cc0274"
	],
	"./Management/MerchantManagement.vue": [
		"51d5",
		9,
		"chunk-2d0be333",
		"chunk-77cc0274"
	],
	"./Management/PaymentList": [
		"988b",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-ee1596b4",
		"chunk-7086244a"
	],
	"./Management/PaymentList.vue": [
		"988b",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-ee1596b4",
		"chunk-7086244a"
	],
	"./Management/QrPayment": [
		"89d9",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-2d0c1967",
		"chunk-ee1596b4",
		"chunk-6bcb69b3"
	],
	"./Management/QrPayment.vue": [
		"89d9",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-2d0c1967",
		"chunk-ee1596b4",
		"chunk-6bcb69b3"
	],
	"./Management/SelectorComponent": [
		"a546",
		9,
		"chunk-f18df898"
	],
	"./Management/SelectorComponent.vue": [
		"a546",
		9,
		"chunk-f18df898"
	],
	"./Management/Setup": [
		"3c48",
		9,
		"chunk-2d0c4a0a"
	],
	"./Management/Setup.vue": [
		"3c48",
		9,
		"chunk-2d0c4a0a"
	],
	"./Management/SetupCs": [
		"3608",
		9,
		"chunk-396f6c4a"
	],
	"./Management/SetupCs.vue": [
		"3608",
		9,
		"chunk-396f6c4a"
	],
	"./Management/SetupFaq": [
		"7453",
		9,
		"chunk-5175d3d4"
	],
	"./Management/SetupFaq.vue": [
		"7453",
		9,
		"chunk-5175d3d4"
	],
	"./Management/SetupNotice": [
		"a879",
		9,
		"chunk-12cc12bc"
	],
	"./Management/SetupNotice.vue": [
		"a879",
		9,
		"chunk-12cc12bc"
	],
	"./Management/TitleComponent": [
		"ecdd",
		9,
		"chunk-4aa15be6"
	],
	"./Management/TitleComponent.vue": [
		"ecdd",
		9,
		"chunk-4aa15be6"
	],
	"./Menu/Auth": [
		"1ddc",
		9,
		"chunk-2d0b6b08"
	],
	"./Menu/Auth.vue": [
		"1ddc",
		9,
		"chunk-2d0b6b08"
	],
	"./Menu/Lang": [
		"5a55",
		9,
		"chunk-65e4ee6f"
	],
	"./Menu/Lang.vue": [
		"5a55",
		9,
		"chunk-65e4ee6f"
	],
	"./Menu/My": [
		"0b2c",
		9,
		"chunk-a30fa6de"
	],
	"./Menu/My.vue": [
		"0b2c",
		9,
		"chunk-a30fa6de"
	],
	"./Menu/Routes": [
		"257c",
		9,
		"chunk-20e30735"
	],
	"./Menu/Routes.vue": [
		"257c",
		9,
		"chunk-20e30735"
	],
	"./Menu/TncSidebar": [
		"2dc6",
		9,
		"chunk-2d0bdf1b"
	],
	"./Menu/TncSidebar.vue": [
		"2dc6",
		9,
		"chunk-2d0bdf1b"
	],
	"./Merchant/Catalog": [
		"735c",
		9,
		"chunk-116ce29e",
		"chunk-33b9c6a3"
	],
	"./Merchant/Catalog.m.backup": [
		"2d68",
		9,
		"chunk-116ce29e",
		"chunk-2b052dbe"
	],
	"./Merchant/Catalog.m.backup.vue": [
		"2d68",
		9,
		"chunk-116ce29e",
		"chunk-2b052dbe"
	],
	"./Merchant/Catalog.vue": [
		"735c",
		9,
		"chunk-116ce29e",
		"chunk-33b9c6a3"
	],
	"./Merchant/Certification/Address": [
		"7a35",
		9,
		"chunk-60b9b88c"
	],
	"./Merchant/Certification/Address.m": [
		"52dbe",
		9,
		"chunk-3d0a00b0"
	],
	"./Merchant/Certification/Address.m.vue": [
		"52dbe",
		9,
		"chunk-3d0a00b0"
	],
	"./Merchant/Certification/Address.vue": [
		"7a35",
		9,
		"chunk-60b9b88c"
	],
	"./Merchant/Certification/Email": [
		"a65c",
		9,
		"chunk-4958015a"
	],
	"./Merchant/Certification/Email.m": [
		"4a19",
		9,
		"chunk-3b6021f0"
	],
	"./Merchant/Certification/Email.m.vue": [
		"4a19",
		9,
		"chunk-3b6021f0"
	],
	"./Merchant/Certification/Email.vue": [
		"a65c",
		9,
		"chunk-4958015a"
	],
	"./Merchant/Certification/Kyc": [
		"2300",
		9,
		"chunk-3b57d692"
	],
	"./Merchant/Certification/Kyc.m": [
		"e048",
		9,
		"chunk-2d224525"
	],
	"./Merchant/Certification/Kyc.m.vue": [
		"e048",
		9,
		"chunk-2d224525"
	],
	"./Merchant/Certification/Kyc.vue": [
		"2300",
		9,
		"chunk-3b57d692"
	],
	"./Merchant/Certification/Otp": [
		"55021",
		9,
		"chunk-47394bde"
	],
	"./Merchant/Certification/Otp.m": [
		"4c1b",
		9,
		"chunk-5e1864be"
	],
	"./Merchant/Certification/Otp.m.vue": [
		"4c1b",
		9,
		"chunk-5e1864be"
	],
	"./Merchant/Certification/Otp.vue": [
		"55021",
		9,
		"chunk-47394bde"
	],
	"./Merchant/Certification/Security": [
		"ea99",
		9,
		"chunk-8aaa0de8"
	],
	"./Merchant/Certification/Security.vue": [
		"ea99",
		9,
		"chunk-8aaa0de8"
	],
	"./Merchant/Certification/SecurityInfo": [
		"7877",
		9,
		"chunk-1a7104fa"
	],
	"./Merchant/Certification/SecurityInfo.vue": [
		"7877",
		9,
		"chunk-1a7104fa"
	],
	"./Merchant/Cs/Faq": [
		"9526",
		9,
		"chunk-e6e1dfd4"
	],
	"./Merchant/Cs/Faq.m.backup": [
		"25a4",
		9,
		"chunk-7e4c9d80"
	],
	"./Merchant/Cs/Faq.m.backup.vue": [
		"25a4",
		9,
		"chunk-7e4c9d80"
	],
	"./Merchant/Cs/Faq.vue": [
		"9526",
		9,
		"chunk-e6e1dfd4"
	],
	"./Merchant/Cs/Inquiry": [
		"2a29",
		9,
		"chunk-a9512210"
	],
	"./Merchant/Cs/Inquiry.m.backup": [
		"2207",
		9,
		"chunk-2bca0a47"
	],
	"./Merchant/Cs/Inquiry.m.backup.vue": [
		"2207",
		9,
		"chunk-2bca0a47"
	],
	"./Merchant/Cs/Inquiry.vue": [
		"2a29",
		9,
		"chunk-a9512210"
	],
	"./Merchant/Cs/InquiryDetail": [
		"9bac",
		9,
		"chunk-1f080fe3"
	],
	"./Merchant/Cs/InquiryDetail.m.backup": [
		"85ed",
		9,
		"chunk-1d7c8352"
	],
	"./Merchant/Cs/InquiryDetail.m.backup.vue": [
		"85ed",
		9,
		"chunk-1d7c8352"
	],
	"./Merchant/Cs/InquiryDetail.vue": [
		"9bac",
		9,
		"chunk-1f080fe3"
	],
	"./Merchant/Cs/InquiryList": [
		"977e",
		9,
		"chunk-82094b72"
	],
	"./Merchant/Cs/InquiryList.m.backup": [
		"5287",
		9,
		"chunk-36b3bed2"
	],
	"./Merchant/Cs/InquiryList.m.backup.vue": [
		"5287",
		9,
		"chunk-36b3bed2"
	],
	"./Merchant/Cs/InquiryList.vue": [
		"977e",
		9,
		"chunk-82094b72"
	],
	"./Merchant/Cs/Notice": [
		"5dcc",
		9,
		"chunk-199485c9"
	],
	"./Merchant/Cs/Notice.m.backup": [
		"f3f1",
		9,
		"chunk-2635b732"
	],
	"./Merchant/Cs/Notice.m.backup.vue": [
		"f3f1",
		9,
		"chunk-2635b732"
	],
	"./Merchant/Cs/Notice.vue": [
		"5dcc",
		9,
		"chunk-199485c9"
	],
	"./Merchant/MerchantPicker": [
		"8350",
		9,
		"chunk-d6c9a464"
	],
	"./Merchant/MerchantPicker.m": [
		"75ec",
		9,
		"chunk-7e1111b4"
	],
	"./Merchant/MerchantPicker.m.vue": [
		"75ec",
		9,
		"chunk-7e1111b4"
	],
	"./Merchant/MerchantPicker.vue": [
		"8350",
		9,
		"chunk-d6c9a464"
	],
	"./Merchant/Settlement/SettlementAccount": [
		"0a28",
		9,
		"chunk-2d0be333",
		"chunk-178b61aa"
	],
	"./Merchant/Settlement/SettlementAccount.m.backup": [
		"6a0f",
		9,
		"chunk-2d0be333",
		"chunk-553c3775"
	],
	"./Merchant/Settlement/SettlementAccount.m.backup.vue": [
		"6a0f",
		9,
		"chunk-2d0be333",
		"chunk-553c3775"
	],
	"./Merchant/Settlement/SettlementAccount.vue": [
		"0a28",
		9,
		"chunk-2d0be333",
		"chunk-178b61aa"
	],
	"./Merchant/Settlement/SettlementAccountDisconnect": [
		"91f3",
		9,
		"chunk-18ccc042"
	],
	"./Merchant/Settlement/SettlementAccountDisconnect.vue": [
		"91f3",
		9,
		"chunk-18ccc042"
	],
	"./Merchant/Settlement/SettlementAccountRegister": [
		"c205",
		9,
		"chunk-2d0be333",
		"chunk-25e56a18"
	],
	"./Merchant/Settlement/SettlementAccountRegister.vue": [
		"c205",
		9,
		"chunk-2d0be333",
		"chunk-25e56a18"
	],
	"./Merchant/Transaction/TransactionList": [
		"caa9",
		9,
		"chunk-6e83591c",
		"chunk-a8062e04",
		"chunk-0f6c39d6"
	],
	"./Merchant/Transaction/TransactionList.m.backup": [
		"2403",
		9,
		"chunk-04fac682"
	],
	"./Merchant/Transaction/TransactionList.m.backup.vue": [
		"2403",
		9,
		"chunk-04fac682"
	],
	"./Merchant/Transaction/TransactionList.vue": [
		"caa9",
		9,
		"chunk-6e83591c",
		"chunk-a8062e04",
		"chunk-0f6c39d6"
	],
	"./Mypage/Account": [
		"d929",
		9,
		"chunk-30a13df8"
	],
	"./Mypage/Account.m.backup": [
		"89e0",
		9,
		"chunk-06ca2e62"
	],
	"./Mypage/Account.m.backup.vue": [
		"89e0",
		9,
		"chunk-06ca2e62"
	],
	"./Mypage/Account.vue": [
		"d929",
		9,
		"chunk-30a13df8"
	],
	"./Mypage/Certification": [
		"ba64",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-5edbd619",
		"chunk-45deceae"
	],
	"./Mypage/Certification.m.backup": [
		"fea4",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-5edbd619",
		"chunk-001d6854"
	],
	"./Mypage/Certification.m.backup.vue": [
		"fea4",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-5edbd619",
		"chunk-001d6854"
	],
	"./Mypage/Certification.vue": [
		"ba64",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-5edbd619",
		"chunk-45deceae"
	],
	"./Mypage/Certification/Address": [
		"8c3f",
		9,
		"chunk-7663cb6a"
	],
	"./Mypage/Certification/Address.m": [
		"5977",
		9,
		"chunk-f64ed870"
	],
	"./Mypage/Certification/Address.m.vue": [
		"5977",
		9,
		"chunk-f64ed870"
	],
	"./Mypage/Certification/Address.vue": [
		"8c3f",
		9,
		"chunk-7663cb6a"
	],
	"./Mypage/Certification/Email": [
		"3ccc",
		9,
		"chunk-3f9ad12d"
	],
	"./Mypage/Certification/Email.m": [
		"84ba",
		9,
		"chunk-5e11c054"
	],
	"./Mypage/Certification/Email.m.vue": [
		"84ba",
		9,
		"chunk-5e11c054"
	],
	"./Mypage/Certification/Email.vue": [
		"3ccc",
		9,
		"chunk-3f9ad12d"
	],
	"./Mypage/Certification/Kyc": [
		"3151",
		9,
		"chunk-5edbd619"
	],
	"./Mypage/Certification/Kyc.m": [
		"237d",
		9,
		"chunk-419df9e5"
	],
	"./Mypage/Certification/Kyc.m.vue": [
		"237d",
		9,
		"chunk-419df9e5"
	],
	"./Mypage/Certification/Kyc.vue": [
		"3151",
		9,
		"chunk-5edbd619"
	],
	"./Mypage/Certification/Otp": [
		"b222",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-67962f86"
	],
	"./Mypage/Certification/Otp.m": [
		"d95e",
		9,
		"chunk-ebbd9ab8"
	],
	"./Mypage/Certification/Otp.m.vue": [
		"d95e",
		9,
		"chunk-ebbd9ab8"
	],
	"./Mypage/Certification/Otp.vue": [
		"b222",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-67962f86"
	],
	"./Mypage/Certification/Security": [
		"c37c",
		9,
		"chunk-2d216832"
	],
	"./Mypage/Certification/Security.vue": [
		"c37c",
		9,
		"chunk-2d216832"
	],
	"./Mypage/Data": [
		"90cb",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-4ae40fe8"
	],
	"./Mypage/Data.m": [
		"d745",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-24fb7c32"
	],
	"./Mypage/Data.m.vue": [
		"d745",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-24fb7c32"
	],
	"./Mypage/Data.vue": [
		"90cb",
		9,
		"chunk-6e83591c",
		"chunk-d3fd1e5a",
		"chunk-df824cdc",
		"chunk-4ae40fe8"
	],
	"./Mypage/SecurityInfo": [
		"a86b",
		9,
		"chunk-2d209219"
	],
	"./Mypage/SecurityInfo.vue": [
		"a86b",
		9,
		"chunk-2d209219"
	],
	"./NewUi/Components/Footer": [
		"3b92",
		9,
		"chunk-33030938"
	],
	"./NewUi/Components/Footer.vue": [
		"3b92",
		9,
		"chunk-33030938"
	],
	"./NewUi/Components/FooterV2": [
		"0ceb",
		9,
		"chunk-33de0d54"
	],
	"./NewUi/Components/FooterV2.vue": [
		"0ceb",
		9,
		"chunk-33de0d54"
	],
	"./NewUi/Components/Header": [
		"f8eb",
		9,
		"chunk-5361c410"
	],
	"./NewUi/Components/Header.vue": [
		"f8eb",
		9,
		"chunk-5361c410"
	],
	"./NewUi/Components/HeaderV2": [
		"cf12",
		9,
		"chunk-ffeccb0e",
		"chunk-2d20edb1"
	],
	"./NewUi/Components/HeaderV2.vue": [
		"cf12",
		9,
		"chunk-ffeccb0e",
		"chunk-2d20edb1"
	],
	"./NewUi/Components/Terms/TermsMobile": [
		"b1f3",
		9,
		"chunk-854b7670"
	],
	"./NewUi/Components/Terms/TermsMobile.vue": [
		"b1f3",
		9,
		"chunk-854b7670"
	],
	"./NewUi/Components/Terms/franchaise/agreement1": [
		"beb6",
		9,
		"chunk-2d21b48d"
	],
	"./NewUi/Components/Terms/franchaise/agreement1.vue": [
		"beb6",
		9,
		"chunk-2d21b48d"
	],
	"./NewUi/Components/Terms/franchaise/agreement10": [
		"9b75",
		9,
		"chunk-2d0f00dd"
	],
	"./NewUi/Components/Terms/franchaise/agreement10.vue": [
		"9b75",
		9,
		"chunk-2d0f00dd"
	],
	"./NewUi/Components/Terms/franchaise/agreement11": [
		"45c9",
		9,
		"chunk-2d0c176d"
	],
	"./NewUi/Components/Terms/franchaise/agreement11.vue": [
		"45c9",
		9,
		"chunk-2d0c176d"
	],
	"./NewUi/Components/Terms/franchaise/agreement12": [
		"97da",
		9,
		"chunk-2d0e6511"
	],
	"./NewUi/Components/Terms/franchaise/agreement12.vue": [
		"97da",
		9,
		"chunk-2d0e6511"
	],
	"./NewUi/Components/Terms/franchaise/agreement13": [
		"85a4",
		9,
		"chunk-2d0de8a6"
	],
	"./NewUi/Components/Terms/franchaise/agreement13.vue": [
		"85a4",
		9,
		"chunk-2d0de8a6"
	],
	"./NewUi/Components/Terms/franchaise/agreement2": [
		"e2f9",
		9,
		"chunk-2d2252b6"
	],
	"./NewUi/Components/Terms/franchaise/agreement2.vue": [
		"e2f9",
		9,
		"chunk-2d2252b6"
	],
	"./NewUi/Components/Terms/franchaise/agreement3": [
		"585c",
		9,
		"chunk-2d0c91a7"
	],
	"./NewUi/Components/Terms/franchaise/agreement3.vue": [
		"585c",
		9,
		"chunk-2d0c91a7"
	],
	"./NewUi/Components/Terms/franchaise/agreement4": [
		"2c01",
		9,
		"chunk-2d0bd528"
	],
	"./NewUi/Components/Terms/franchaise/agreement4.vue": [
		"2c01",
		9,
		"chunk-2d0bd528"
	],
	"./NewUi/Components/Terms/franchaise/agreement5": [
		"f7ca",
		9,
		"chunk-2d22d9a5"
	],
	"./NewUi/Components/Terms/franchaise/agreement5.vue": [
		"f7ca",
		9,
		"chunk-2d22d9a5"
	],
	"./NewUi/Components/Terms/franchaise/agreement6": [
		"2a0f",
		9,
		"chunk-2d0bcddb"
	],
	"./NewUi/Components/Terms/franchaise/agreement6.vue": [
		"2a0f",
		9,
		"chunk-2d0bcddb"
	],
	"./NewUi/Components/Terms/franchaise/agreement7": [
		"5f39",
		9,
		"chunk-2d0d3ded"
	],
	"./NewUi/Components/Terms/franchaise/agreement7.vue": [
		"5f39",
		9,
		"chunk-2d0d3ded"
	],
	"./NewUi/Components/Terms/franchaise/agreement8": [
		"2f4f",
		9,
		"chunk-2d0be11c"
	],
	"./NewUi/Components/Terms/franchaise/agreement8.vue": [
		"2f4f",
		9,
		"chunk-2d0be11c"
	],
	"./NewUi/Components/Terms/franchaise/agreement9": [
		"1cf0",
		9,
		"chunk-2d0b6752"
	],
	"./NewUi/Components/Terms/franchaise/agreement9.vue": [
		"1cf0",
		9,
		"chunk-2d0b6752"
	],
	"./NewUi/Components/Terms/guidline/guide1": [
		"6e26",
		9,
		"chunk-2d0dae69"
	],
	"./NewUi/Components/Terms/guidline/guide1.vue": [
		"6e26",
		9,
		"chunk-2d0dae69"
	],
	"./NewUi/Components/Terms/guidline/guide2": [
		"3b00",
		9,
		"chunk-2d0c45c5"
	],
	"./NewUi/Components/Terms/guidline/guide2.vue": [
		"3b00",
		9,
		"chunk-2d0c45c5"
	],
	"./NewUi/Components/Terms/legal/legal1": [
		"73e0",
		9,
		"chunk-2d0d6d3d"
	],
	"./NewUi/Components/Terms/legal/legal1.vue": [
		"73e0",
		9,
		"chunk-2d0d6d3d"
	],
	"./NewUi/Components/Terms/legal/legal2": [
		"488a",
		9,
		"chunk-2d0c1da3"
	],
	"./NewUi/Components/Terms/legal/legal2.vue": [
		"488a",
		9,
		"chunk-2d0c1da3"
	],
	"./NewUi/Components/Terms/legal/legal3": [
		"607d",
		9,
		"chunk-2d0ce83d"
	],
	"./NewUi/Components/Terms/legal/legal3.vue": [
		"607d",
		9,
		"chunk-2d0ce83d"
	],
	"./NewUi/Components/Terms/legal/legal4": [
		"088c",
		9,
		"chunk-2d0a4c29"
	],
	"./NewUi/Components/Terms/legal/legal4.vue": [
		"088c",
		9,
		"chunk-2d0a4c29"
	],
	"./NewUi/Components/Terms/legal/legal5": [
		"a5f0",
		9,
		"chunk-2d208c74"
	],
	"./NewUi/Components/Terms/legal/legal5.vue": [
		"a5f0",
		9,
		"chunk-2d208c74"
	],
	"./NewUi/Components/Terms/legal/legal6": [
		"7918",
		9,
		"chunk-2d0d7d7f"
	],
	"./NewUi/Components/Terms/legal/legal6.vue": [
		"7918",
		9,
		"chunk-2d0d7d7f"
	],
	"./NewUi/Components/Terms/legal/legal7": [
		"a456",
		9,
		"chunk-2d2082ca"
	],
	"./NewUi/Components/Terms/legal/legal7.vue": [
		"a456",
		9,
		"chunk-2d2082ca"
	],
	"./NewUi/Components/Terms/legal/legal8": [
		"bd53",
		9,
		"chunk-2d21ab56"
	],
	"./NewUi/Components/Terms/legal/legal8.vue": [
		"bd53",
		9,
		"chunk-2d21ab56"
	],
	"./NewUi/Components/Terms/legal/legal9": [
		"740e",
		9,
		"chunk-2d0d6ac8"
	],
	"./NewUi/Components/Terms/legal/legal9.vue": [
		"740e",
		9,
		"chunk-2d0d6ac8"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement1-mobile": [
		"effb",
		9,
		"chunk-0dbb2c70"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement1-mobile.vue": [
		"effb",
		9,
		"chunk-0dbb2c70"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement10-mobile": [
		"25b0",
		9,
		"chunk-2d0b2e87"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement10-mobile.vue": [
		"25b0",
		9,
		"chunk-2d0b2e87"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement11-mobile": [
		"717e",
		9,
		"chunk-2d0d605e"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement11-mobile.vue": [
		"717e",
		9,
		"chunk-2d0d605e"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement12-mobile": [
		"bd5a",
		9,
		"chunk-2d21ab84"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement12-mobile.vue": [
		"bd5a",
		9,
		"chunk-2d21ab84"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement13-mobile": [
		"6c60",
		9,
		"chunk-2d0da75d"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement13-mobile.vue": [
		"6c60",
		9,
		"chunk-2d0da75d"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement2-mobile": [
		"bde6",
		9,
		"chunk-2d21b129"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement2-mobile.vue": [
		"bde6",
		9,
		"chunk-2d21b129"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement3-mobile": [
		"8b73",
		9,
		"chunk-2d0e8c7c"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement3-mobile.vue": [
		"8b73",
		9,
		"chunk-2d0e8c7c"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement4-mobile": [
		"c0a0",
		9,
		"chunk-2d2161d2"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement4-mobile.vue": [
		"c0a0",
		9,
		"chunk-2d2161d2"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement5-mobile": [
		"d8ea",
		9,
		"chunk-2d21f4e6"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement5-mobile.vue": [
		"d8ea",
		9,
		"chunk-2d21f4e6"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement6-mobile": [
		"e472",
		9,
		"chunk-2d225480"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement6-mobile.vue": [
		"e472",
		9,
		"chunk-2d225480"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement7-mobile": [
		"71bf",
		9,
		"chunk-2d0d6594"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement7-mobile.vue": [
		"71bf",
		9,
		"chunk-2d0d6594"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement8-mobile": [
		"a4c7",
		9,
		"chunk-2d20885d"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement8-mobile.vue": [
		"a4c7",
		9,
		"chunk-2d20885d"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement9-mobile": [
		"338c",
		9,
		"chunk-2d0b9681"
	],
	"./NewUi/Components/Terms/mobile/franchaise/agreement9-mobile.vue": [
		"338c",
		9,
		"chunk-2d0b9681"
	],
	"./NewUi/Components/Terms/mobile/guidline/guide1-mobile": [
		"a0f8",
		9,
		"chunk-2d2079b7"
	],
	"./NewUi/Components/Terms/mobile/guidline/guide1-mobile.vue": [
		"a0f8",
		9,
		"chunk-2d2079b7"
	],
	"./NewUi/Components/Terms/mobile/guidline/guide2-mobile": [
		"a674",
		9,
		"chunk-2d208a88"
	],
	"./NewUi/Components/Terms/mobile/guidline/guide2-mobile.vue": [
		"a674",
		9,
		"chunk-2d208a88"
	],
	"./NewUi/Components/Terms/mobile/legal/legal1-mobile": [
		"2a39",
		9,
		"chunk-2d0bce0b"
	],
	"./NewUi/Components/Terms/mobile/legal/legal1-mobile.vue": [
		"2a39",
		9,
		"chunk-2d0bce0b"
	],
	"./NewUi/Components/Terms/mobile/legal/legal2-mobile": [
		"f5dfd",
		9,
		"chunk-773776fd"
	],
	"./NewUi/Components/Terms/mobile/legal/legal2-mobile.vue": [
		"f5dfd",
		9,
		"chunk-773776fd"
	],
	"./NewUi/Components/Terms/mobile/legal/legal3-mobile": [
		"fff8",
		9,
		"chunk-2d238a48"
	],
	"./NewUi/Components/Terms/mobile/legal/legal3-mobile.vue": [
		"fff8",
		9,
		"chunk-2d238a48"
	],
	"./NewUi/Components/Terms/mobile/legal/legal4-mobile": [
		"f3a3",
		9,
		"chunk-2d22ca35"
	],
	"./NewUi/Components/Terms/mobile/legal/legal4-mobile.vue": [
		"f3a3",
		9,
		"chunk-2d22ca35"
	],
	"./NewUi/Components/Terms/mobile/legal/legal5-mobile": [
		"2316",
		9,
		"chunk-2d0b211c"
	],
	"./NewUi/Components/Terms/mobile/legal/legal5-mobile.vue": [
		"2316",
		9,
		"chunk-2d0b211c"
	],
	"./NewUi/Components/Terms/mobile/legal/legal6-mobile": [
		"6934",
		9,
		"chunk-2d0d095a"
	],
	"./NewUi/Components/Terms/mobile/legal/legal6-mobile.vue": [
		"6934",
		9,
		"chunk-2d0d095a"
	],
	"./NewUi/Components/Terms/mobile/legal/legal7-mobile": [
		"1307",
		9,
		"chunk-2d0aac9f"
	],
	"./NewUi/Components/Terms/mobile/legal/legal7-mobile.vue": [
		"1307",
		9,
		"chunk-2d0aac9f"
	],
	"./NewUi/Components/Terms/mobile/legal/legal8-mobile": [
		"dd5c",
		9,
		"chunk-2d229444"
	],
	"./NewUi/Components/Terms/mobile/legal/legal8-mobile.vue": [
		"dd5c",
		9,
		"chunk-2d229444"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy1-mobile": [
		"6084",
		9,
		"chunk-2d0ce82c"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy1-mobile.vue": [
		"6084",
		9,
		"chunk-2d0ce82c"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy2-mobile": [
		"649d",
		9,
		"chunk-2d0cf77f"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy2-mobile.vue": [
		"649d",
		9,
		"chunk-2d0cf77f"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy3-mobile": [
		"ac1a",
		9,
		"chunk-2d2132e8"
	],
	"./NewUi/Components/Terms/mobile/privacy/privacy3-mobile.vue": [
		"ac1a",
		9,
		"chunk-2d2132e8"
	],
	"./NewUi/Components/Terms/privacy/privacy1": [
		"d36e",
		9,
		"chunk-2d21dc74"
	],
	"./NewUi/Components/Terms/privacy/privacy1.vue": [
		"d36e",
		9,
		"chunk-2d21dc74"
	],
	"./NewUi/Components/Terms/privacy/privacy2": [
		"8ba9",
		9,
		"chunk-2d0e9198"
	],
	"./NewUi/Components/Terms/privacy/privacy2.vue": [
		"8ba9",
		9,
		"chunk-2d0e9198"
	],
	"./NewUi/Components/Terms/privacy/privacy3": [
		"454d",
		9,
		"chunk-2d0c11e7"
	],
	"./NewUi/Components/Terms/privacy/privacy3.vue": [
		"454d",
		9,
		"chunk-2d0c11e7"
	],
	"./NewUi/Layout/HFW": [
		"2bf1",
		9,
		"chunk-ffeccb0e",
		"chunk-5ca50bd4"
	],
	"./NewUi/Layout/HFW.vue": [
		"2bf1",
		9,
		"chunk-ffeccb0e",
		"chunk-5ca50bd4"
	],
	"./NewUi/Layout/MainLayout": [
		"28f8",
		9,
		"chunk-ffeccb0e",
		"chunk-da5c3752"
	],
	"./NewUi/Layout/MainLayout.vue": [
		"28f8",
		9,
		"chunk-ffeccb0e",
		"chunk-da5c3752"
	],
	"./NewUi/Page/Account": [
		"03bb",
		9,
		"chunk-56910192"
	],
	"./NewUi/Page/Account.vue": [
		"03bb",
		9,
		"chunk-56910192"
	],
	"./NewUi/Page/Account_v2": [
		"20ec1",
		9,
		"chunk-cfcc0228"
	],
	"./NewUi/Page/Account_v2.vue": [
		"20ec1",
		9,
		"chunk-cfcc0228"
	],
	"./NewUi/Page/Addonetether": [
		"b145",
		9,
		"chunk-68be3c14"
	],
	"./NewUi/Page/Addonetether.vue": [
		"b145",
		9,
		"chunk-68be3c14"
	],
	"./NewUi/Page/Addonetether_v2": [
		"7839f",
		9,
		"chunk-5f7ff79a"
	],
	"./NewUi/Page/Addonetether_v2.vue": [
		"7839f",
		9,
		"chunk-5f7ff79a"
	],
	"./NewUi/Page/Business-asset": [
		"6ad2",
		9,
		"chunk-654fef80"
	],
	"./NewUi/Page/Business-asset-v2": [
		"6746",
		9,
		"chunk-5624607a"
	],
	"./NewUi/Page/Business-asset-v2.vue": [
		"6746",
		9,
		"chunk-5624607a"
	],
	"./NewUi/Page/Business-asset.vue": [
		"6ad2",
		9,
		"chunk-654fef80"
	],
	"./NewUi/Page/Business-corps": [
		"f79a",
		9,
		"chunk-1f7b0db9"
	],
	"./NewUi/Page/Business-corps-v2": [
		"a008",
		9,
		"chunk-d36635be"
	],
	"./NewUi/Page/Business-corps-v2.vue": [
		"a008",
		9,
		"chunk-d36635be"
	],
	"./NewUi/Page/Business-corps.vue": [
		"f79a",
		9,
		"chunk-1f7b0db9"
	],
	"./NewUi/Page/Business-global": [
		"fee6",
		9,
		"chunk-b2ac42f0"
	],
	"./NewUi/Page/Business-global-v2": [
		"2b1b",
		9,
		"chunk-511596b1"
	],
	"./NewUi/Page/Business-global-v2.vue": [
		"2b1b",
		9,
		"chunk-511596b1"
	],
	"./NewUi/Page/Business-global.vue": [
		"fee6",
		9,
		"chunk-b2ac42f0"
	],
	"./NewUi/Page/Business-method": [
		"eff5",
		9,
		"chunk-09a74a08"
	],
	"./NewUi/Page/Business-method-v2": [
		"53e9",
		9,
		"chunk-478ca19d"
	],
	"./NewUi/Page/Business-method-v2.vue": [
		"53e9",
		9,
		"chunk-478ca19d"
	],
	"./NewUi/Page/Business-method.vue": [
		"eff5",
		9,
		"chunk-09a74a08"
	],
	"./NewUi/Page/Business-pay-v2": [
		"fdce",
		9,
		"chunk-bf9fa484"
	],
	"./NewUi/Page/Business-pay-v2.vue": [
		"fdce",
		9,
		"chunk-bf9fa484"
	],
	"./NewUi/Page/Business-platform": [
		"0f94",
		9,
		"chunk-7807c657"
	],
	"./NewUi/Page/Business-platform-v2": [
		"0be0",
		9,
		"chunk-f1fc3c2e"
	],
	"./NewUi/Page/Business-platform-v2.vue": [
		"0be0",
		9,
		"chunk-f1fc3c2e"
	],
	"./NewUi/Page/Business-platform.vue": [
		"0f94",
		9,
		"chunk-7807c657"
	],
	"./NewUi/Page/Business-receive": [
		"d431",
		9,
		"chunk-7e59b2e9"
	],
	"./NewUi/Page/Business-receive.vue": [
		"d431",
		9,
		"chunk-7e59b2e9"
	],
	"./NewUi/Page/Business-receive_v2": [
		"594e",
		9,
		"chunk-ea8197d6"
	],
	"./NewUi/Page/Business-receive_v2.vue": [
		"594e",
		9,
		"chunk-ea8197d6"
	],
	"./NewUi/Page/Commission": [
		"0b9c",
		9,
		"chunk-0b40c475"
	],
	"./NewUi/Page/Commission.vue": [
		"0b9c",
		9,
		"chunk-0b40c475"
	],
	"./NewUi/Page/Commission_v2": [
		"49ed",
		9,
		"chunk-a64e11a4"
	],
	"./NewUi/Page/Commission_v2.vue": [
		"49ed",
		9,
		"chunk-a64e11a4"
	],
	"./NewUi/Page/Cookies": [
		"37a7",
		9,
		"chunk-30f5fb40"
	],
	"./NewUi/Page/Cookies.vue": [
		"37a7",
		9,
		"chunk-30f5fb40"
	],
	"./NewUi/Page/Creditcard": [
		"b642",
		9,
		"chunk-3bedfe52"
	],
	"./NewUi/Page/Creditcard.vue": [
		"b642",
		9,
		"chunk-3bedfe52"
	],
	"./NewUi/Page/Creditcard_v2": [
		"11b0",
		9,
		"chunk-72d6c602"
	],
	"./NewUi/Page/Creditcard_v2.vue": [
		"11b0",
		9,
		"chunk-72d6c602"
	],
	"./NewUi/Page/Deposit": [
		"d7df",
		9,
		"chunk-3e8a55d0"
	],
	"./NewUi/Page/Deposit.vue": [
		"d7df",
		9,
		"chunk-3e8a55d0"
	],
	"./NewUi/Page/Deposit_v2": [
		"45e6",
		9,
		"chunk-7b6784ba"
	],
	"./NewUi/Page/Deposit_v2.vue": [
		"45e6",
		9,
		"chunk-7b6784ba"
	],
	"./NewUi/Page/Development": [
		"3ce4",
		9,
		"chunk-de956cc0"
	],
	"./NewUi/Page/Development-v2": [
		"6211",
		9,
		"chunk-b107312a"
	],
	"./NewUi/Page/Development-v2.vue": [
		"6211",
		9,
		"chunk-b107312a"
	],
	"./NewUi/Page/Development.vue": [
		"3ce4",
		9,
		"chunk-de956cc0"
	],
	"./NewUi/Page/Development_main": [
		"40d3",
		9,
		"chunk-783e7f4b"
	],
	"./NewUi/Page/Development_main.vue": [
		"40d3",
		9,
		"chunk-783e7f4b"
	],
	"./NewUi/Page/Development_main_v2": [
		"fac0",
		9,
		"chunk-2d23771e"
	],
	"./NewUi/Page/Development_main_v2.vue": [
		"fac0",
		9,
		"chunk-2d23771e"
	],
	"./NewUi/Page/Exchange": [
		"9a16",
		9,
		"chunk-3f5b8f65"
	],
	"./NewUi/Page/Exchange.vue": [
		"9a16",
		9,
		"chunk-3f5b8f65"
	],
	"./NewUi/Page/Exchange_v2": [
		"32e6",
		9,
		"chunk-1bd73f31"
	],
	"./NewUi/Page/Exchange_v2.vue": [
		"32e6",
		9,
		"chunk-1bd73f31"
	],
	"./NewUi/Page/Franchaise": [
		"d9ba",
		9,
		"chunk-854b7670",
		"chunk-2d21f84a"
	],
	"./NewUi/Page/Franchaise.vue": [
		"d9ba",
		9,
		"chunk-854b7670",
		"chunk-2d21f84a"
	],
	"./NewUi/Page/Guideline": [
		"1eec",
		9,
		"chunk-854b7670",
		"chunk-2d0b6ee8"
	],
	"./NewUi/Page/Guideline.vue": [
		"1eec",
		9,
		"chunk-854b7670",
		"chunk-2d0b6ee8"
	],
	"./NewUi/Page/Home": [
		"d4ee",
		9,
		"chunk-11c3fe1b"
	],
	"./NewUi/Page/Home.css": [
		"5d81",
		7,
		"chunk-7499a921"
	],
	"./NewUi/Page/Home.vue": [
		"d4ee",
		9,
		"chunk-11c3fe1b"
	],
	"./NewUi/Page/HomeV2": [
		"439c",
		9,
		"chunk-196f9aca"
	],
	"./NewUi/Page/HomeV2.vue": [
		"439c",
		9,
		"chunk-196f9aca"
	],
	"./NewUi/Page/Legal": [
		"94a5",
		9,
		"chunk-854b7670",
		"chunk-2d0e5945"
	],
	"./NewUi/Page/Legal.vue": [
		"94a5",
		9,
		"chunk-854b7670",
		"chunk-2d0e5945"
	],
	"./NewUi/Page/Offline_kiosk": [
		"f305",
		9,
		"chunk-67ebe239"
	],
	"./NewUi/Page/Offline_kiosk.vue": [
		"f305",
		9,
		"chunk-67ebe239"
	],
	"./NewUi/Page/Offline_kiosk_v2": [
		"b35f",
		9,
		"chunk-19e781de"
	],
	"./NewUi/Page/Offline_kiosk_v2.vue": [
		"b35f",
		9,
		"chunk-19e781de"
	],
	"./NewUi/Page/Online_shopping": [
		"3216",
		9,
		"chunk-de40385c"
	],
	"./NewUi/Page/Online_shopping.vue": [
		"3216",
		9,
		"chunk-de40385c"
	],
	"./NewUi/Page/Online_shopping_V2": [
		"fda3",
		9,
		"chunk-b2a673b4"
	],
	"./NewUi/Page/Online_shopping_V2.vue": [
		"fda3",
		9,
		"chunk-b2a673b4"
	],
	"./NewUi/Page/Privacy": [
		"51bc",
		9,
		"chunk-854b7670",
		"chunk-2d0c7cd3"
	],
	"./NewUi/Page/Privacy.vue": [
		"51bc",
		9,
		"chunk-854b7670",
		"chunk-2d0c7cd3"
	],
	"./NewUi/Page/Qr": [
		"a3c2",
		9,
		"chunk-372d5e32"
	],
	"./NewUi/Page/Qr.vue": [
		"a3c2",
		9,
		"chunk-372d5e32"
	],
	"./NewUi/Page/Qr_v2": [
		"fd8e",
		9,
		"chunk-19af339d"
	],
	"./NewUi/Page/Qr_v2.vue": [
		"fd8e",
		9,
		"chunk-19af339d"
	],
	"./NewUi/Page/Receive": [
		"625e",
		9,
		"chunk-e42c2f08"
	],
	"./NewUi/Page/Receive.vue": [
		"625e",
		9,
		"chunk-e42c2f08"
	],
	"./NewUi/Page/Receive_v2": [
		"466b",
		9,
		"chunk-ac8a6854"
	],
	"./NewUi/Page/Receive_v2.vue": [
		"466b",
		9,
		"chunk-ac8a6854"
	],
	"./NewUi/Page/Risk": [
		"f8d9",
		9,
		"chunk-36d26e6a"
	],
	"./NewUi/Page/Risk-v2": [
		"fc1e",
		9,
		"chunk-22bccbc9"
	],
	"./NewUi/Page/Risk-v2.vue": [
		"fc1e",
		9,
		"chunk-22bccbc9"
	],
	"./NewUi/Page/Risk.vue": [
		"f8d9",
		9,
		"chunk-36d26e6a"
	],
	"./NewUi/Page/Sale": [
		"ef8d",
		9,
		"chunk-f9e5a8b6"
	],
	"./NewUi/Page/Sale.vue": [
		"ef8d",
		9,
		"chunk-f9e5a8b6"
	],
	"./NewUi/Page/Sale_v2": [
		"4b5a",
		9,
		"chunk-1eb4772e"
	],
	"./NewUi/Page/Sale_v2.vue": [
		"4b5a",
		9,
		"chunk-1eb4772e"
	],
	"./NewUi/Page/Send": [
		"dfb2",
		9,
		"chunk-5eaff1de"
	],
	"./NewUi/Page/Send.vue": [
		"dfb2",
		9,
		"chunk-5eaff1de"
	],
	"./NewUi/Page/Send_v2": [
		"0a6a",
		9,
		"chunk-505501e6"
	],
	"./NewUi/Page/Send_v2.vue": [
		"0a6a",
		9,
		"chunk-505501e6"
	],
	"./NewUi/Page/Start": [
		"1e05",
		9,
		"chunk-4f9a340a"
	],
	"./NewUi/Page/Start.vue": [
		"1e05",
		9,
		"chunk-4f9a340a"
	],
	"./NewUi/Page/Start_v2": [
		"86ac",
		9,
		"chunk-e7906b76"
	],
	"./NewUi/Page/Start_v2.vue": [
		"86ac",
		9,
		"chunk-e7906b76"
	],
	"./NewUi/Page/Tradecashback": [
		"f0f8",
		9,
		"chunk-966ea6ae"
	],
	"./NewUi/Page/Tradecashback.vue": [
		"f0f8",
		9,
		"chunk-966ea6ae"
	],
	"./NewUi/Page/Tradecashback_v2": [
		"b59b",
		9,
		"chunk-3948a496"
	],
	"./NewUi/Page/Tradecashback_v2.vue": [
		"b59b",
		9,
		"chunk-3948a496"
	],
	"./NewUi/Page/Wallet": [
		"ab84",
		9,
		"chunk-7decd2d7"
	],
	"./NewUi/Page/Wallet.vue": [
		"ab84",
		9,
		"chunk-7decd2d7"
	],
	"./NewUi/Page/Wallet_v2": [
		"7bf6",
		9,
		"chunk-3db2625f"
	],
	"./NewUi/Page/Wallet_v2.vue": [
		"7bf6",
		9,
		"chunk-3db2625f"
	],
	"./Pagination": [
		"1799",
		9,
		"chunk-4c3d26ec"
	],
	"./Pagination.vue": [
		"1799",
		9,
		"chunk-4c3d26ec"
	],
	"./PaymentStatisticsChart": [
		"731b",
		9,
		"chunk-116ce29e"
	],
	"./PaymentStatisticsChart.vue": [
		"731b",
		9,
		"chunk-116ce29e"
	],
	"./Privacy": [
		"654e",
		9,
		"chunk-04232758"
	],
	"./Privacy.m": [
		"4447",
		9,
		"chunk-2d89efe2"
	],
	"./Privacy.m.vue": [
		"4447",
		9,
		"chunk-2d89efe2"
	],
	"./Privacy.vue": [
		"654e",
		9,
		"chunk-04232758"
	],
	"./QrReader": [
		"5fc0",
		9,
		"chunk-2d0c1967",
		"chunk-34b1c19d"
	],
	"./QrReader.vue": [
		"5fc0",
		9,
		"chunk-2d0c1967",
		"chunk-34b1c19d"
	],
	"./Service/Business/Asset/Pay": [
		"e01c",
		9,
		"chunk-2d2244f3"
	],
	"./Service/Business/Asset/Pay.m": [
		"d463",
		9,
		"chunk-74a0640d",
		"chunk-2d21e003"
	],
	"./Service/Business/Asset/Pay.m.vue": [
		"d463",
		9,
		"chunk-74a0640d",
		"chunk-2d21e003"
	],
	"./Service/Business/Asset/Pay.vue": [
		"e01c",
		9,
		"chunk-2d2244f3"
	],
	"./Service/Business/How/Pay": [
		"bfed",
		9,
		"chunk-680b8823"
	],
	"./Service/Business/How/Pay.m": [
		"b2c1",
		9,
		"chunk-74a0640d",
		"chunk-2df2ab30"
	],
	"./Service/Business/How/Pay.m.vue": [
		"b2c1",
		9,
		"chunk-74a0640d",
		"chunk-2df2ab30"
	],
	"./Service/Business/How/Pay.vue": [
		"bfed",
		9,
		"chunk-680b8823"
	],
	"./Service/Business/How/Receive": [
		"9f0a",
		9,
		"chunk-78734a5e"
	],
	"./Service/Business/How/Receive.m": [
		"2943",
		9,
		"chunk-74a0640d",
		"chunk-550272d4"
	],
	"./Service/Business/How/Receive.m.vue": [
		"2943",
		9,
		"chunk-74a0640d",
		"chunk-550272d4"
	],
	"./Service/Business/How/Receive.vue": [
		"9f0a",
		9,
		"chunk-78734a5e"
	],
	"./Service/Business/How/Risk": [
		"391e",
		9,
		"chunk-b5dbb056"
	],
	"./Service/Business/How/Risk.m": [
		"d3d6",
		9,
		"chunk-74a0640d",
		"chunk-7bdab8bc"
	],
	"./Service/Business/How/Risk.m.vue": [
		"d3d6",
		9,
		"chunk-74a0640d",
		"chunk-7bdab8bc"
	],
	"./Service/Business/How/Risk.vue": [
		"391e",
		9,
		"chunk-b5dbb056"
	],
	"./Service/Business/How/Start": [
		"b30a",
		9,
		"chunk-2d20f2f8"
	],
	"./Service/Business/How/Start.m": [
		"d5ae",
		9,
		"chunk-74a0640d",
		"chunk-2d21e92b"
	],
	"./Service/Business/How/Start.m.vue": [
		"d5ae",
		9,
		"chunk-74a0640d",
		"chunk-2d21e92b"
	],
	"./Service/Business/How/Start.vue": [
		"b30a",
		9,
		"chunk-2d20f2f8"
	],
	"./Service/Business/Operation/Corps": [
		"4abd",
		9,
		"chunk-2d0cbca5"
	],
	"./Service/Business/Operation/Corps.m": [
		"4076",
		9,
		"chunk-74a0640d",
		"chunk-2d0bff51"
	],
	"./Service/Business/Operation/Corps.m.vue": [
		"4076",
		9,
		"chunk-74a0640d",
		"chunk-2d0bff51"
	],
	"./Service/Business/Operation/Corps.vue": [
		"4abd",
		9,
		"chunk-2d0cbca5"
	],
	"./Service/Business/Operation/Global": [
		"2a92",
		9,
		"chunk-2d0bcebe"
	],
	"./Service/Business/Operation/Global.m": [
		"f5b9",
		9,
		"chunk-74a0640d",
		"chunk-2d22d1dc"
	],
	"./Service/Business/Operation/Global.m.vue": [
		"f5b9",
		9,
		"chunk-74a0640d",
		"chunk-2d22d1dc"
	],
	"./Service/Business/Operation/Global.vue": [
		"2a92",
		9,
		"chunk-2d0bcebe"
	],
	"./Service/Business/Operation/Pay": [
		"81eb",
		9,
		"chunk-2d0dda4c"
	],
	"./Service/Business/Operation/Pay.m": [
		"ff0b",
		9,
		"chunk-74a0640d",
		"chunk-2d2383e8"
	],
	"./Service/Business/Operation/Pay.m.vue": [
		"ff0b",
		9,
		"chunk-74a0640d",
		"chunk-2d2383e8"
	],
	"./Service/Business/Operation/Pay.vue": [
		"81eb",
		9,
		"chunk-2d0dda4c"
	],
	"./Service/Business/Operation/Platform": [
		"69a6",
		9,
		"chunk-2d0d0eee"
	],
	"./Service/Business/Operation/Platform.m": [
		"bb8d",
		9,
		"chunk-74a0640d",
		"chunk-2d21a462"
	],
	"./Service/Business/Operation/Platform.m.vue": [
		"bb8d",
		9,
		"chunk-74a0640d",
		"chunk-2d21a462"
	],
	"./Service/Business/Operation/Platform.vue": [
		"69a6",
		9,
		"chunk-2d0d0eee"
	],
	"./Service/Cs/Cs": [
		"110c",
		9,
		"chunk-657dfb18",
		"chunk-61890270"
	],
	"./Service/Cs/Cs.vue": [
		"110c",
		9,
		"chunk-657dfb18",
		"chunk-61890270"
	],
	"./Service/Cs/Faq": [
		"6e61",
		9,
		"chunk-34336487"
	],
	"./Service/Cs/Faq.m.backup": [
		"4b13",
		9,
		"chunk-0753372a"
	],
	"./Service/Cs/Faq.m.backup.vue": [
		"4b13",
		9,
		"chunk-0753372a"
	],
	"./Service/Cs/Faq.vue": [
		"6e61",
		9,
		"chunk-34336487"
	],
	"./Service/Cs/Inquiry": [
		"f491",
		9,
		"chunk-657dfb18"
	],
	"./Service/Cs/Inquiry.m.backup": [
		"afdd",
		9,
		"chunk-4fe386d7"
	],
	"./Service/Cs/Inquiry.m.backup.vue": [
		"afdd",
		9,
		"chunk-4fe386d7"
	],
	"./Service/Cs/Inquiry.vue": [
		"f491",
		9,
		"chunk-657dfb18"
	],
	"./Service/Cs/InquiryDetail": [
		"0c2b",
		9,
		"chunk-08ddf4f6"
	],
	"./Service/Cs/InquiryDetail.m.backup": [
		"67f4",
		9,
		"chunk-ef37cc04"
	],
	"./Service/Cs/InquiryDetail.m.backup.vue": [
		"67f4",
		9,
		"chunk-ef37cc04"
	],
	"./Service/Cs/InquiryDetail.vue": [
		"0c2b",
		9,
		"chunk-08ddf4f6"
	],
	"./Service/Cs/Notice": [
		"504f",
		9,
		"chunk-6121ba7e"
	],
	"./Service/Cs/Notice.m.backup": [
		"6b1d",
		9,
		"chunk-c2f24e84"
	],
	"./Service/Cs/Notice.m.backup.vue": [
		"6b1d",
		9,
		"chunk-c2f24e84"
	],
	"./Service/Cs/Notice.vue": [
		"504f",
		9,
		"chunk-6121ba7e"
	],
	"./Service/Personal/Asset/Account": [
		"f83b",
		9,
		"chunk-2d22d797"
	],
	"./Service/Personal/Asset/Account.m": [
		"97d2",
		9,
		"chunk-74a0640d",
		"chunk-2d0e64e2"
	],
	"./Service/Personal/Asset/Account.m.vue": [
		"97d2",
		9,
		"chunk-74a0640d",
		"chunk-2d0e64e2"
	],
	"./Service/Personal/Asset/Account.vue": [
		"f83b",
		9,
		"chunk-2d22d797"
	],
	"./Service/Personal/Asset/Exchange": [
		"0bb5",
		9,
		"chunk-2d0aeebb"
	],
	"./Service/Personal/Asset/Exchange.m": [
		"df45",
		9,
		"chunk-74a0640d",
		"chunk-2d229b79"
	],
	"./Service/Personal/Asset/Exchange.m.vue": [
		"df45",
		9,
		"chunk-74a0640d",
		"chunk-2d229b79"
	],
	"./Service/Personal/Asset/Exchange.vue": [
		"0bb5",
		9,
		"chunk-2d0aeebb"
	],
	"./Service/Personal/Asset/Jpys": [
		"52f6",
		9,
		"chunk-2d0c80e3"
	],
	"./Service/Personal/Asset/Jpys.m": [
		"bcc1",
		9,
		"chunk-74a0640d",
		"chunk-2d21ad25"
	],
	"./Service/Personal/Asset/Jpys.m.vue": [
		"bcc1",
		9,
		"chunk-74a0640d",
		"chunk-2d21ad25"
	],
	"./Service/Personal/Asset/Jpys.vue": [
		"52f6",
		9,
		"chunk-2d0c80e3"
	],
	"./Service/Personal/Asset/Sale": [
		"4863",
		9,
		"chunk-2d0c1d37"
	],
	"./Service/Personal/Asset/Sale.m": [
		"5222",
		9,
		"chunk-74a0640d",
		"chunk-2d0c7a93"
	],
	"./Service/Personal/Asset/Sale.m.vue": [
		"5222",
		9,
		"chunk-74a0640d",
		"chunk-2d0c7a93"
	],
	"./Service/Personal/Asset/Sale.vue": [
		"4863",
		9,
		"chunk-2d0c1d37"
	],
	"./Service/Personal/Asset/Wallet": [
		"0d7d",
		9,
		"chunk-2d0af137"
	],
	"./Service/Personal/Asset/Wallet.m": [
		"60e7",
		9,
		"chunk-74a0640d",
		"chunk-2d0ceda2"
	],
	"./Service/Personal/Asset/Wallet.m.vue": [
		"60e7",
		9,
		"chunk-74a0640d",
		"chunk-2d0ceda2"
	],
	"./Service/Personal/Asset/Wallet.vue": [
		"0d7d",
		9,
		"chunk-2d0af137"
	],
	"./Service/Personal/How/JanopayCreditcard": [
		"c751",
		9,
		"chunk-28dd0d57"
	],
	"./Service/Personal/How/JanopayCreditcard.m": [
		"be64",
		9,
		"chunk-74a0640d",
		"chunk-2e2ba6f0"
	],
	"./Service/Personal/How/JanopayCreditcard.m.vue": [
		"be64",
		9,
		"chunk-74a0640d",
		"chunk-2e2ba6f0"
	],
	"./Service/Personal/How/JanopayCreditcard.vue": [
		"c751",
		9,
		"chunk-28dd0d57"
	],
	"./Service/Personal/How/OfflineKiosk": [
		"71ee",
		9,
		"chunk-40814be2"
	],
	"./Service/Personal/How/OfflineKiosk.m": [
		"4a35",
		9,
		"chunk-74a0640d",
		"chunk-4d37cb36"
	],
	"./Service/Personal/How/OfflineKiosk.m.vue": [
		"4a35",
		9,
		"chunk-74a0640d",
		"chunk-4d37cb36"
	],
	"./Service/Personal/How/OfflineKiosk.vue": [
		"71ee",
		9,
		"chunk-40814be2"
	],
	"./Service/Personal/How/OnlineShopping": [
		"fd98",
		9,
		"chunk-94be9dd6"
	],
	"./Service/Personal/How/OnlineShopping.m": [
		"6f95",
		9,
		"chunk-74a0640d",
		"chunk-7022ff3e"
	],
	"./Service/Personal/How/OnlineShopping.m.vue": [
		"6f95",
		9,
		"chunk-74a0640d",
		"chunk-7022ff3e"
	],
	"./Service/Personal/How/OnlineShopping.vue": [
		"fd98",
		9,
		"chunk-94be9dd6"
	],
	"./Service/Personal/How/Qr": [
		"8687",
		9,
		"chunk-76041ae2"
	],
	"./Service/Personal/How/Qr.m": [
		"4a50",
		9,
		"chunk-74a0640d",
		"chunk-bcc3f134"
	],
	"./Service/Personal/How/Qr.m.vue": [
		"4a50",
		9,
		"chunk-74a0640d",
		"chunk-bcc3f134"
	],
	"./Service/Personal/How/Qr.vue": [
		"8687",
		9,
		"chunk-76041ae2"
	],
	"./Service/Personal/How/TradeAndCashback": [
		"ad995",
		9,
		"chunk-03c6a3cd"
	],
	"./Service/Personal/How/TradeAndCashback.m": [
		"096f",
		9,
		"chunk-74a0640d",
		"chunk-ba8c6040"
	],
	"./Service/Personal/How/TradeAndCashback.m.vue": [
		"096f",
		9,
		"chunk-74a0640d",
		"chunk-ba8c6040"
	],
	"./Service/Personal/How/TradeAndCashback.vue": [
		"ad995",
		9,
		"chunk-03c6a3cd"
	],
	"./Service/Personal/Request/Commission": [
		"0ba2",
		9,
		"chunk-2d0aee99"
	],
	"./Service/Personal/Request/Commission.m": [
		"5ef3",
		9,
		"chunk-74a0640d",
		"chunk-2d0d4053"
	],
	"./Service/Personal/Request/Commission.m.vue": [
		"5ef3",
		9,
		"chunk-74a0640d",
		"chunk-2d0d4053"
	],
	"./Service/Personal/Request/Commission.vue": [
		"0ba2",
		9,
		"chunk-2d0aee99"
	],
	"./Service/Personal/Request/Deposit": [
		"3534",
		9,
		"chunk-2d0b9d39"
	],
	"./Service/Personal/Request/Deposit.m": [
		"27a3",
		9,
		"chunk-74a0640d",
		"chunk-2d0b35ed"
	],
	"./Service/Personal/Request/Deposit.m.vue": [
		"27a3",
		9,
		"chunk-74a0640d",
		"chunk-2d0b35ed"
	],
	"./Service/Personal/Request/Deposit.vue": [
		"3534",
		9,
		"chunk-2d0b9d39"
	],
	"./Service/Personal/Request/Receive": [
		"c1c3",
		9,
		"chunk-6af7c9d4"
	],
	"./Service/Personal/Request/Receive.m": [
		"0190",
		9,
		"chunk-74a0640d",
		"chunk-13cd61ce"
	],
	"./Service/Personal/Request/Receive.m.vue": [
		"0190",
		9,
		"chunk-74a0640d",
		"chunk-13cd61ce"
	],
	"./Service/Personal/Request/Receive.vue": [
		"c1c3",
		9,
		"chunk-6af7c9d4"
	],
	"./Service/Personal/Request/Send": [
		"7cb7",
		9,
		"chunk-5f9a2987"
	],
	"./Service/Personal/Request/Send.m": [
		"cad4",
		9,
		"chunk-74a0640d",
		"chunk-6056bc54"
	],
	"./Service/Personal/Request/Send.m.vue": [
		"cad4",
		9,
		"chunk-74a0640d",
		"chunk-6056bc54"
	],
	"./Service/Personal/Request/Send.vue": [
		"7cb7",
		9,
		"chunk-5f9a2987"
	],
	"./Terms": [
		"d5d2",
		9,
		"chunk-2d21e955"
	],
	"./Terms.m": [
		"10bb",
		9,
		"chunk-3ce04e6d"
	],
	"./Terms.m.vue": [
		"10bb",
		9,
		"chunk-3ce04e6d"
	],
	"./Terms.vue": [
		"d5d2",
		9,
		"chunk-2d21e955"
	],
	"./Terms/FranchiseAgreement/Agreement1": [
		"079b",
		9,
		"chunk-2d0a4886"
	],
	"./Terms/FranchiseAgreement/Agreement1.vue": [
		"079b",
		9,
		"chunk-2d0a4886"
	],
	"./Terms/FranchiseAgreement/Agreement10": [
		"2102",
		9,
		"chunk-2d0b1977"
	],
	"./Terms/FranchiseAgreement/Agreement10.vue": [
		"2102",
		9,
		"chunk-2d0b1977"
	],
	"./Terms/FranchiseAgreement/Agreement11": [
		"d967",
		9,
		"chunk-2d21f2cc"
	],
	"./Terms/FranchiseAgreement/Agreement11.vue": [
		"d967",
		9,
		"chunk-2d21f2cc"
	],
	"./Terms/FranchiseAgreement/Agreement12": [
		"6c50",
		9,
		"chunk-2d0da73e"
	],
	"./Terms/FranchiseAgreement/Agreement12.vue": [
		"6c50",
		9,
		"chunk-2d0da73e"
	],
	"./Terms/FranchiseAgreement/Agreement13": [
		"47ff",
		9,
		"chunk-2d0c1f79"
	],
	"./Terms/FranchiseAgreement/Agreement13.vue": [
		"47ff",
		9,
		"chunk-2d0c1f79"
	],
	"./Terms/FranchiseAgreement/Agreement2": [
		"43d5",
		9,
		"chunk-2d0c1006"
	],
	"./Terms/FranchiseAgreement/Agreement2.vue": [
		"43d5",
		9,
		"chunk-2d0c1006"
	],
	"./Terms/FranchiseAgreement/Agreement3": [
		"ec79",
		9,
		"chunk-2d2304f6"
	],
	"./Terms/FranchiseAgreement/Agreement3.vue": [
		"ec79",
		9,
		"chunk-2d2304f6"
	],
	"./Terms/FranchiseAgreement/Agreement4": [
		"e56f",
		9,
		"chunk-2d225856"
	],
	"./Terms/FranchiseAgreement/Agreement4.vue": [
		"e56f",
		9,
		"chunk-2d225856"
	],
	"./Terms/FranchiseAgreement/Agreement5": [
		"3493",
		9,
		"chunk-2d0b9a31"
	],
	"./Terms/FranchiseAgreement/Agreement5.vue": [
		"3493",
		9,
		"chunk-2d0b9a31"
	],
	"./Terms/FranchiseAgreement/Agreement6": [
		"3fda",
		9,
		"chunk-2d0c5b46"
	],
	"./Terms/FranchiseAgreement/Agreement6.vue": [
		"3fda",
		9,
		"chunk-2d0c5b46"
	],
	"./Terms/FranchiseAgreement/Agreement7": [
		"a11b",
		9,
		"chunk-2d207737"
	],
	"./Terms/FranchiseAgreement/Agreement7.vue": [
		"a11b",
		9,
		"chunk-2d207737"
	],
	"./Terms/FranchiseAgreement/Agreement8": [
		"c29f",
		9,
		"chunk-2d2164b2"
	],
	"./Terms/FranchiseAgreement/Agreement8.vue": [
		"c29f",
		9,
		"chunk-2d2164b2"
	],
	"./Terms/FranchiseAgreement/Agreement9": [
		"6afa",
		9,
		"chunk-2d0da5dc"
	],
	"./Terms/FranchiseAgreement/Agreement9.vue": [
		"6afa",
		9,
		"chunk-2d0da5dc"
	],
	"./Terms/Guideline/Guideline1": [
		"04c6",
		9,
		"chunk-2d0a422d"
	],
	"./Terms/Guideline/Guideline1.vue": [
		"04c6",
		9,
		"chunk-2d0a422d"
	],
	"./Terms/Guideline/Guideline2": [
		"ed87",
		9,
		"chunk-2d2308d4"
	],
	"./Terms/Guideline/Guideline2.vue": [
		"ed87",
		9,
		"chunk-2d2308d4"
	],
	"./Terms/LegalIndication/LegalIndication1": [
		"2107",
		9,
		"chunk-2d0b197c"
	],
	"./Terms/LegalIndication/LegalIndication1.vue": [
		"2107",
		9,
		"chunk-2d0b197c"
	],
	"./Terms/LegalIndication/LegalIndication2": [
		"4576",
		9,
		"chunk-2d0c1216"
	],
	"./Terms/LegalIndication/LegalIndication2.vue": [
		"4576",
		9,
		"chunk-2d0c1216"
	],
	"./Terms/LegalIndication/LegalIndication3": [
		"0c79",
		9,
		"chunk-2d0aed4b"
	],
	"./Terms/LegalIndication/LegalIndication3.vue": [
		"0c79",
		9,
		"chunk-2d0aed4b"
	],
	"./Terms/LegalIndication/LegalIndication4": [
		"8dcf",
		9,
		"chunk-2d0e9985"
	],
	"./Terms/LegalIndication/LegalIndication4.vue": [
		"8dcf",
		9,
		"chunk-2d0e9985"
	],
	"./Terms/LegalIndication/LegalIndication5": [
		"ce12",
		9,
		"chunk-2d2222f9"
	],
	"./Terms/LegalIndication/LegalIndication5.vue": [
		"ce12",
		9,
		"chunk-2d2222f9"
	],
	"./Terms/LegalIndication/LegalIndication6": [
		"70a3",
		9,
		"chunk-2d0d6181"
	],
	"./Terms/LegalIndication/LegalIndication6.vue": [
		"70a3",
		9,
		"chunk-2d0d6181"
	],
	"./Terms/LegalIndication/LegalIndication7": [
		"d9d5",
		9,
		"chunk-2d21f85c"
	],
	"./Terms/LegalIndication/LegalIndication7.vue": [
		"d9d5",
		9,
		"chunk-2d21f85c"
	],
	"./Terms/LegalIndication/LegalIndication8": [
		"1fbc",
		9,
		"chunk-2d0b724c"
	],
	"./Terms/LegalIndication/LegalIndication8.vue": [
		"1fbc",
		9,
		"chunk-2d0b724c"
	],
	"./Terms/LegalIndication/LegalIndication9": [
		"dc3f",
		9,
		"chunk-2d229048"
	],
	"./Terms/LegalIndication/LegalIndication9.vue": [
		"dc3f",
		9,
		"chunk-2d229048"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy1": [
		"7b54",
		9,
		"chunk-2d0e17e0"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy1.vue": [
		"7b54",
		9,
		"chunk-2d0e17e0"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy2": [
		"639a",
		9,
		"chunk-2d0cf3bb"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy2.vue": [
		"639a",
		9,
		"chunk-2d0cf3bb"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy3": [
		"66ed",
		9,
		"chunk-2d0d0455"
	],
	"./Terms/PrivacyPolicy/PrivacyPolicy3.vue": [
		"66ed",
		9,
		"chunk-2d0d0455"
	],
	"./Tutorial": [
		"7a79",
		9,
		"chunk-13828b66"
	],
	"./Tutorial.vue": [
		"7a79",
		9,
		"chunk-13828b66"
	],
	"./UnderConstruction": [
		"7816",
		9,
		"chunk-2a345108"
	],
	"./UnderConstruction.vue": [
		"7816",
		9,
		"chunk-2a345108"
	],
	"./User/Activity/Activity": [
		"d821",
		9,
		"chunk-6e83591c",
		"chunk-a8062e04",
		"chunk-007ec402"
	],
	"./User/Activity/Activity.m.backup": [
		"aac3",
		9,
		"chunk-2aafe176"
	],
	"./User/Activity/Activity.m.backup.vue": [
		"aac3",
		9,
		"chunk-2aafe176"
	],
	"./User/Activity/Activity.vue": [
		"d821",
		9,
		"chunk-6e83591c",
		"chunk-a8062e04",
		"chunk-007ec402"
	],
	"./User/Activity/ActivityDetail": [
		"7231",
		9,
		"chunk-b4abdbd2"
	],
	"./User/Activity/ActivityDetail.vue": [
		"7231",
		9,
		"chunk-b4abdbd2"
	],
	"./User/Activity/C2c": [
		"dc7a",
		9,
		"chunk-4f621674",
		"chunk-2a446a1c",
		"chunk-1ffa1784"
	],
	"./User/Activity/C2c.m.backup": [
		"b1e9",
		9,
		"chunk-777de304",
		"chunk-9afd9e5a",
		"chunk-6b924872"
	],
	"./User/Activity/C2c.m.backup.vue": [
		"b1e9",
		9,
		"chunk-777de304",
		"chunk-9afd9e5a",
		"chunk-6b924872"
	],
	"./User/Activity/C2c.vue": [
		"dc7a",
		9,
		"chunk-4f621674",
		"chunk-2a446a1c",
		"chunk-1ffa1784"
	],
	"./User/Activity/Exchange": [
		"45e3",
		9,
		"chunk-05a50a36"
	],
	"./User/Activity/Exchange.m.backup": [
		"1565",
		9,
		"chunk-07bb6f21"
	],
	"./User/Activity/Exchange.m.backup.vue": [
		"1565",
		9,
		"chunk-07bb6f21"
	],
	"./User/Activity/Exchange.vue": [
		"45e3",
		9,
		"chunk-05a50a36"
	],
	"./User/Activity/ExchangeDetail": [
		"0a18b",
		9,
		"chunk-41c73ebd"
	],
	"./User/Activity/ExchangeDetail.m.backup": [
		"1673",
		9,
		"chunk-2d0ab8b7"
	],
	"./User/Activity/ExchangeDetail.m.backup.vue": [
		"1673",
		9,
		"chunk-2d0ab8b7"
	],
	"./User/Activity/ExchangeDetail.vue": [
		"0a18b",
		9,
		"chunk-41c73ebd"
	],
	"./User/Activity/Invoice": [
		"70e1",
		9,
		"chunk-0d805551"
	],
	"./User/Activity/Invoice.m": [
		"1bcf",
		9,
		"chunk-4a6c6657"
	],
	"./User/Activity/Invoice.m.vue": [
		"1bcf",
		9,
		"chunk-4a6c6657"
	],
	"./User/Activity/Invoice.vue": [
		"70e1",
		9,
		"chunk-0d805551"
	],
	"./User/Activity/Purchase": [
		"b429",
		9,
		"chunk-779a9728"
	],
	"./User/Activity/Purchase.m.backup": [
		"85fc",
		9,
		"chunk-4f175692"
	],
	"./User/Activity/Purchase.m.backup.vue": [
		"85fc",
		9,
		"chunk-4f175692"
	],
	"./User/Activity/Purchase.vue": [
		"b429",
		9,
		"chunk-779a9728"
	],
	"./User/Activity/PurchaseDetail": [
		"9447",
		9,
		"chunk-2a446a1c",
		"chunk-d6a37cb0"
	],
	"./User/Activity/PurchaseDetail.m.backup": [
		"8865",
		9,
		"chunk-9afd9e5a",
		"chunk-c9831a34"
	],
	"./User/Activity/PurchaseDetail.m.backup.vue": [
		"8865",
		9,
		"chunk-9afd9e5a",
		"chunk-c9831a34"
	],
	"./User/Activity/PurchaseDetail.vue": [
		"9447",
		9,
		"chunk-2a446a1c",
		"chunk-d6a37cb0"
	],
	"./User/Activity/Sale": [
		"eb11",
		9,
		"chunk-b7d66e16"
	],
	"./User/Activity/Sale.m.backup": [
		"daf2",
		9,
		"chunk-129bdc50"
	],
	"./User/Activity/Sale.m.backup.vue": [
		"daf2",
		9,
		"chunk-129bdc50"
	],
	"./User/Activity/Sale.vue": [
		"eb11",
		9,
		"chunk-b7d66e16"
	],
	"./User/Activity/SaleDetail": [
		"e54b",
		9,
		"chunk-3253e7e7"
	],
	"./User/Activity/SaleDetail.m.backup": [
		"25a7",
		9,
		"chunk-80018400"
	],
	"./User/Activity/SaleDetail.m.backup.vue": [
		"25a7",
		9,
		"chunk-80018400"
	],
	"./User/Activity/SaleDetail.vue": [
		"e54b",
		9,
		"chunk-3253e7e7"
	],
	"./User/Activity/SaleDetailList": [
		"8289",
		9,
		"chunk-4f621674"
	],
	"./User/Activity/SaleDetailList.m.backup": [
		"f2cc",
		9,
		"chunk-777de304"
	],
	"./User/Activity/SaleDetailList.m.backup.vue": [
		"f2cc",
		9,
		"chunk-777de304"
	],
	"./User/Activity/SaleDetailList.vue": [
		"8289",
		9,
		"chunk-4f621674"
	],
	"./User/Cs/CustomerTop": [
		"84b9",
		9,
		"chunk-5327901a"
	],
	"./User/Cs/CustomerTop.vue": [
		"84b9",
		9,
		"chunk-5327901a"
	],
	"./User/Cs/Faq": [
		"ee5e",
		9,
		"chunk-a873f86a"
	],
	"./User/Cs/Faq.m.backup": [
		"5abb",
		9,
		"chunk-9f319294"
	],
	"./User/Cs/Faq.m.backup.vue": [
		"5abb",
		9,
		"chunk-9f319294"
	],
	"./User/Cs/Faq.vue": [
		"ee5e",
		9,
		"chunk-a873f86a"
	],
	"./User/Cs/Inquiry": [
		"efca",
		9,
		"chunk-7d83c3a0"
	],
	"./User/Cs/Inquiry.m.backup": [
		"3942",
		9,
		"chunk-6247654a"
	],
	"./User/Cs/Inquiry.m.backup.vue": [
		"3942",
		9,
		"chunk-6247654a"
	],
	"./User/Cs/Inquiry.vue": [
		"efca",
		9,
		"chunk-7d83c3a0"
	],
	"./User/Cs/InquiryDetail": [
		"a81e",
		9,
		"chunk-096b3054"
	],
	"./User/Cs/InquiryDetail.m.backup": [
		"c042",
		9,
		"chunk-ef9cbcba"
	],
	"./User/Cs/InquiryDetail.m.backup.vue": [
		"c042",
		9,
		"chunk-ef9cbcba"
	],
	"./User/Cs/InquiryDetail.vue": [
		"a81e",
		9,
		"chunk-096b3054"
	],
	"./User/Cs/InquiryList": [
		"afb1",
		9,
		"chunk-1cefcb1c"
	],
	"./User/Cs/InquiryList.m.backup": [
		"9d9b",
		9,
		"chunk-0497d67b"
	],
	"./User/Cs/InquiryList.m.backup.vue": [
		"9d9b",
		9,
		"chunk-0497d67b"
	],
	"./User/Cs/InquiryList.vue": [
		"afb1",
		9,
		"chunk-1cefcb1c"
	],
	"./User/Cs/Notice": [
		"e761",
		9,
		"chunk-130547d0"
	],
	"./User/Cs/Notice.m.backup": [
		"a769",
		9,
		"chunk-2490f666"
	],
	"./User/Cs/Notice.m.backup.vue": [
		"a769",
		9,
		"chunk-2490f666"
	],
	"./User/Cs/Notice.vue": [
		"e761",
		9,
		"chunk-130547d0"
	],
	"./User/Pay/AssetSearch": [
		"f311",
		9,
		"chunk-2d0be333",
		"chunk-2ede5e94"
	],
	"./User/Pay/AssetSearch.m": [
		"52db",
		9,
		"chunk-2d0be333",
		"chunk-4a659315"
	],
	"./User/Pay/AssetSearch.m.vue": [
		"52db",
		9,
		"chunk-2d0be333",
		"chunk-4a659315"
	],
	"./User/Pay/AssetSearch.vue": [
		"f311",
		9,
		"chunk-2d0be333",
		"chunk-2ede5e94"
	],
	"./User/Pay/C2c": [
		"28b8",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-5266e63e",
		"chunk-4862a004",
		"chunk-6fc002de"
	],
	"./User/Pay/C2c.m.backup": [
		"969d",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-16125f79",
		"chunk-31d267ef",
		"chunk-58cc531e"
	],
	"./User/Pay/C2c.m.backup.vue": [
		"969d",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-16125f79",
		"chunk-31d267ef",
		"chunk-58cc531e"
	],
	"./User/Pay/C2c.vue": [
		"28b8",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-5266e63e",
		"chunk-4862a004",
		"chunk-6fc002de"
	],
	"./User/Pay/C2cBuy": [
		"4172",
		9,
		"chunk-4862a004",
		"chunk-e70a46e6"
	],
	"./User/Pay/C2cBuy.m": [
		"1d50",
		9,
		"chunk-31d267ef",
		"chunk-3a53aea5"
	],
	"./User/Pay/C2cBuy.m.vue": [
		"1d50",
		9,
		"chunk-31d267ef",
		"chunk-3a53aea5"
	],
	"./User/Pay/C2cBuy.vue": [
		"4172",
		9,
		"chunk-4862a004",
		"chunk-e70a46e6"
	],
	"./User/Pay/C2cSell": [
		"c7bd",
		9,
		"chunk-2d0be333",
		"chunk-5266e63e",
		"chunk-2d20edb1"
	],
	"./User/Pay/C2cSell.m": [
		"eb9a",
		9,
		"chunk-2d0be333",
		"chunk-16125f79",
		"chunk-2d20edb1"
	],
	"./User/Pay/C2cSell.m.vue": [
		"eb9a",
		9,
		"chunk-2d0be333",
		"chunk-16125f79",
		"chunk-2d20edb1"
	],
	"./User/Pay/C2cSell.vue": [
		"c7bd",
		9,
		"chunk-2d0be333",
		"chunk-5266e63e",
		"chunk-2d20edb1"
	],
	"./User/Pay/CheckAccount": [
		"c5cc",
		9,
		"chunk-312a1c20"
	],
	"./User/Pay/CheckAccount.m": [
		"e920",
		9,
		"chunk-1f838300"
	],
	"./User/Pay/CheckAccount.m.vue": [
		"e920",
		9,
		"chunk-1f838300"
	],
	"./User/Pay/CheckAccount.vue": [
		"c5cc",
		9,
		"chunk-312a1c20"
	],
	"./User/Pay/Contacts": [
		"aac1",
		9,
		"chunk-ef43db44"
	],
	"./User/Pay/Contacts.vue": [
		"aac1",
		9,
		"chunk-ef43db44"
	],
	"./User/Pay/ContactsFriendsInfo": [
		"7eee",
		9,
		"chunk-2d0e2924"
	],
	"./User/Pay/ContactsFriendsInfo.vue": [
		"7eee",
		9,
		"chunk-2d0e2924"
	],
	"./User/Pay/ContactsInfoTab": [
		"8b50",
		9,
		"chunk-69ab6b79"
	],
	"./User/Pay/ContactsInfoTab.vue": [
		"8b50",
		9,
		"chunk-69ab6b79"
	],
	"./User/Pay/ContactsMyInfo": [
		"62ca",
		9,
		"chunk-2d0cf510"
	],
	"./User/Pay/ContactsMyInfo.vue": [
		"62ca",
		9,
		"chunk-2d0cf510"
	],
	"./User/Pay/Deposit": [
		"5e3d",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-7a71c09d"
	],
	"./User/Pay/Deposit.m.backup": [
		"e129",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-beadd3be",
		"chunk-7210b6e5"
	],
	"./User/Pay/Deposit.m.backup.vue": [
		"e129",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-beadd3be",
		"chunk-7210b6e5"
	],
	"./User/Pay/Deposit.vue": [
		"5e3d",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-7a71c09d"
	],
	"./User/Pay/Exchange": [
		"56ef1",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-1cb36725"
	],
	"./User/Pay/Exchange.m.backup": [
		"1dbe",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-d68ad8d6"
	],
	"./User/Pay/Exchange.m.backup.vue": [
		"1dbe",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-d68ad8d6"
	],
	"./User/Pay/Exchange.vue": [
		"56ef1",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-1cb36725"
	],
	"./User/Pay/Invoice": [
		"7493",
		9,
		"chunk-6691791b"
	],
	"./User/Pay/Invoice.vue": [
		"7493",
		9,
		"chunk-6691791b"
	],
	"./User/Pay/Payment": [
		"5c02",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-16ff77a8"
	],
	"./User/Pay/Payment.m.backup": [
		"c467",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-2d0c1967",
		"chunk-beadd3be",
		"chunk-a9d037d2"
	],
	"./User/Pay/Payment.m.backup.vue": [
		"c467",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-2d0c1967",
		"chunk-beadd3be",
		"chunk-a9d037d2"
	],
	"./User/Pay/Payment.vue": [
		"5c02",
		9,
		"chunk-2d0be333",
		"chunk-13828b66",
		"chunk-16ff77a8"
	],
	"./User/WalletAccount/Account": [
		"b035",
		9,
		"chunk-18347725"
	],
	"./User/WalletAccount/Account.vue": [
		"b035",
		9,
		"chunk-18347725"
	],
	"./User/WalletAccount/AssetsList": [
		"b890",
		9,
		"chunk-69d1c596"
	],
	"./User/WalletAccount/AssetsList.m.backup": [
		"9cee",
		9,
		"chunk-0c728178"
	],
	"./User/WalletAccount/AssetsList.m.backup.vue": [
		"9cee",
		9,
		"chunk-0c728178"
	],
	"./User/WalletAccount/AssetsList.vue": [
		"b890",
		9,
		"chunk-69d1c596"
	],
	"./User/WalletAccount/Wallet": [
		"60c9",
		9,
		"chunk-2d0be333",
		"chunk-037dad5e"
	],
	"./User/WalletAccount/Wallet.vue": [
		"60c9",
		9,
		"chunk-2d0be333",
		"chunk-037dad5e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ce68";
module.exports = webpackAsyncContext;